import type { IError } from "@/shared/common/types";
import { ListContentWrapper } from "@/shared/components/ListContentWrapper";
import type { ReactNode } from "react";

interface Props {
  children: ReactNode;
  isEmpty?: boolean;
  isFetching: boolean;
  isError: boolean;
  error: IError;
  refetch: () => void;
  emptyTitle?: string;
  emptySubtitle?: string;
}

export const PageWidgetTemplate = ({
  children,
  isEmpty,
  isFetching,
  isError,
  error,
  refetch,
  emptyTitle,
  emptySubtitle,
}: Props) => {

  return (
    <div className="full-width widget">
      <div className="widget-content full-width">
        <ListContentWrapper
          isError={isError}
          isFetching={isFetching}
          isEmpty={isEmpty}
          error={error}
          refetch={refetch}
          emptyTitle={emptyTitle}
          emptySubtitle={emptySubtitle}
        >
          {children}
        </ListContentWrapper>
      </div>
    </div>
  );
};
